import { useEffect } from 'react'

import { DashboardDeviceSlidePresentation } from 'Modules/dashboard/components/DashboardDevices/DashboardDeviceSlide.presentation'

import { Heading } from 'Components/_theme'
import { ActionButtonPresentation } from 'Components/_theme/ActionButton/ActionButton.presentation'
import { AlertPresentation } from 'Components/_theme/Alert/Alert.presentation'
import { BadgePresentation } from 'Components/_theme/Badge/Badge.presentation'
import { BannerPresentation } from 'Components/_theme/Banner/Banner.presentation'
import { ButtonGroupPresentation } from 'Components/_theme/ButtonGroup/ButtonGroup.presentation'
import { CardHeaderPresentation } from 'Components/_theme/CardHeader/CardHeader.presentation'
import { CheckboxPresentation } from 'Components/_theme/Checkbox/Checkbox.presentation'
import { HeadingPresentation } from 'Components/_theme/Heading/Heading.presentation'
import { InputPresentation } from 'Components/_theme/Input/Input.presentation'
import { LabelPresentation } from 'Components/_theme/Label/Label.presentation'
import { LinkButtonPresentation } from 'Components/_theme/LinkButton/LinkButton.presentation'
import { NavigationButtonPresentation } from 'Components/_theme/NavigationButton/NavigationButton.presentation'
import { PrimaryButtonPresentation } from 'Components/_theme/PrimaryButton/PrimaryButton.presentation'
import { RadioPresentation } from 'Components/_theme/RadioButton/Radio.presentation'
import { SecondaryButtonPresentation } from 'Components/_theme/SecondaryButton/SecondaryButton.presentation'
import { TertiaryButtonPresentation } from 'Components/_theme/TertiaryButton/TertiaryButton.presentation'
import { TextareaPresentation } from 'Components/_theme/Textarea/Textarea.presentation'
import { WidgetPresentation } from 'Components/_theme/Widget/Widget.presentation'

import { NewPhonePlanModalPresentation } from 'Modals/NewPhonePlanModal/NewPhonePlanModal.presentation'

import { useStore } from 'Stores/index'

export const Presentation = () => {
  const { portalSettingsStore } = useStore()
  const { setIsCompactSidebar } = portalSettingsStore

  useEffect(() => {
    setIsCompactSidebar(true)

    return () => {
      setIsCompactSidebar(false)
    }
  }, [setIsCompactSidebar])

  return (
    <div className="presentation">
      <Heading className="pt-4" size={2}>
        UI presentation
      </Heading>

      <PrimaryButtonPresentation />

      <hr className="hr-presentation" />

      <SecondaryButtonPresentation />

      <hr className="hr-presentation" />

      <TertiaryButtonPresentation />

      <hr className="hr-presentation" />

      <LinkButtonPresentation />

      <hr className="hr-presentation" />

      <ActionButtonPresentation />

      <hr className="hr-presentation" />

      <ButtonGroupPresentation />

      <hr className="hr-presentation" />

      <NavigationButtonPresentation />

      <hr className="hr-presentation" />

      <HeadingPresentation />

      <hr className="hr-presentation" />

      <AlertPresentation />

      <hr className="hr-presentation" />

      <BadgePresentation />

      <hr className="hr-presentation" />

      <TextareaPresentation />

      <hr className="hr-presentation" />

      <CheckboxPresentation />

      <hr className="hr-presentation" />

      <RadioPresentation />

      <hr className="hr-presentation" />

      <InputPresentation />

      <hr className="hr-presentation" />

      <LabelPresentation />

      <hr className="hr-presentation" />

      <DashboardDeviceSlidePresentation />

      <hr className="hr-presentation" />

      <BannerPresentation />

      <hr className="hr-presentation" />

      <WidgetPresentation />

      <hr className="hr-presentation" />

      <NavigationButtonPresentation />

      <hr className="hr-presentation" />

      <NewPhonePlanModalPresentation />

      <hr className="hr-presentation" />

      <CardHeaderPresentation />
    </div>
  )
}
